// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Switch, Route, withRouter, Redirect,
} from 'react-router-dom';

import styles from './App.scss';
import './styles/react-table.global.css';
import './styles/typeahead.global.css';

import { fetchActiveAccount } from './actions/accountActions';

import PrintPatientPage from './components/patientPages/print/PrintPatientPage.jsx';
import PatientTemplate from './components/patientPages/PatientTemplate.jsx';
import PharmacyTemplate from './components/pharmacyPages/PharmacyTemplate.jsx';
import AddPatientPage from './components/addPatientPage/AddPatientPage.jsx';
import SearchPage from './components/searchPage/SearchPage.jsx';
import UpdatesPage from './components/updatesPage/UpdatesPage.jsx';
import LoginPage from './components/accountPages/LoginPage.jsx';
import SignupPage from './components/accountPages/SignupPage.jsx';
import AccountPage from './components/accountPages/AccountPage.jsx';
import MonthlyReportPage from './components/monthlyReportPages/MonthlyReportPage.jsx';

type Props = {
  activeAccount: Object,
  fetchPatientStatus: string,
  fetchAccountStatus: string,
  fetchActiveAccount: Function,
}

// Use redirects as default routes to maintain proper URLs
class LoginRedirect extends Component<{}> {
  render() {
    return <Redirect to='/login' />;
  }
}

class SearchRedirect extends Component<{}> {
  render() {
    return <Redirect to='/search' />;
  }
}

class AppComponent extends Component<Props> {
  componentDidMount() {
    this.props.fetchActiveAccount();
  }

  render() {
    if (this.props.fetchAccountStatus === 'ERROR'
      || (this.props.fetchAccountStatus === 'SUCCESS' && !this.props.activeAccount)) {
      return <div className={styles.app}>
        <Switch>
          <Route path='/signup' component={SignupPage} />
          <Route path='/login' component={LoginPage} />
          <Route component={LoginRedirect} />
        </Switch>
      </div>;
    }
    return (
      <div className={styles.app}>
        <Switch>
          {this.props.fetchPatientStatus === 'SUCCESS'
            && <Route path='/patient/:id/print' component={PrintPatientPage} />
          }
          <Route path='/patient/:id' component={PatientTemplate} />
          <Route path='/pharmacy' component={PharmacyTemplate} />
          <Route path='/addPatient' component={AddPatientPage} />
          <Route path='/search' component={SearchPage} />
          <Route path='/updates' component={UpdatesPage} />
          <Route path='/account' component={AccountPage} />
          <Route path='/monthlyReport' component={MonthlyReportPage} />
          <Route component={SearchRedirect} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetchPatientStatus: state.patient.status,
  fetchAccountStatus: state.account.status,
  activeAccount: state.account.activeAccount,
});

const mapDispatchToProps = dispatch => ({
  fetchActiveAccount: () => dispatch(fetchActiveAccount()),
});

const App = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppComponent));

export default App;



// WEBPACK FOOTER //
// ./client/src/App.jsx